var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sd-group-member-wrapper"},[_c('div',{staticClass:"sd-group-member-icon-wrapper"},[_c('font-awesome-icon',{staticClass:"sd-group-icon",attrs:{"icon":"user-plus","size":"xs"}})],1),_vm._v(" "),_c('span',{staticClass:"sd-group-icon-text"},[_vm._v(_vm._s(_vm.caption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }